import React, { useState } from "react";
import DefaultButton from "../../styles/materialButtonStyle";

import { DelayInput } from "react-delay-input/lib/Component";
import DatePicker from "../../elements/datePicker/DatePicker";
import { DateToTimestamp, TimestampToDate } from "../../../utils/timestampToDate";
import Dropdown from "rc-dropdown";
import { useTranslation } from "react-i18next";


import { StyledDatepicker } from "../../styles/styledDatepicker";
import {
  StyledFilterBlock,
  StyledFilterBlockTitle,
  StyledFilterCloseBtn,
  StyledFilterDropdownWrapper,
  StyledFilterGroup, StyledFilterWrapper, StyledSelectGroup, StyledShowFilterBtn
} from "../../elements/filter/styledFiter";
import TransactionStatusSelect from "../../elements/riskScore/RiskScoreStatusSelect";

const BatchesFilter = ({ filterData, setFilterData }) => {
  const { t } = useTranslation("batchesPage");

  const DEFAULT_FILTER_DATA = {
    "page": 1,
    "itemsPerPage": filterData["itemsPerPage"] ?? null,
    "name": "",
    "amount[gte]": "",
    "amount[lte]": "",
    "processedAmount[gte]": "",
    "processedAmount[lte]": ""
  };

  const [visible, setVisible] = useState(false);

  const onVisibleChange = (visible) => {
    setVisible(visible);
  };

  const handleClearFilter = () => {
    setFilterData(DEFAULT_FILTER_DATA);
  };

  const FilterList = () => {
    return (
      <>
        {visible &&
        <StyledFilterDropdownWrapper>
          <StyledFilterBlock actions>
            <StyledFilterGroup className="clear-btn">
              <DefaultButton
                color="transparent"
                onClick={handleClearFilter}
              >
                {t("filter.clearBtn")}
              </DefaultButton>
            </StyledFilterGroup>
            <StyledFilterGroup className="close-btn">
              <StyledFilterCloseBtn onClick={() => setVisible(false)} />
            </StyledFilterGroup>
          </StyledFilterBlock>
          <StyledFilterBlockTitle>
            {t("filter.filterBy")}:
          </StyledFilterBlockTitle>
          <StyledFilterBlock col="2">
            <StyledFilterGroup>
              <label htmlFor="name">
                {t("filter.name")}
              </label>
              <DelayInput
                id="name"
                delayTimeout={2000}
                onChange={event => setFilterData({ ...filterData, "name": event.target.value, page: 1 })}
                name="name"
                value={filterData["name"]}
                type="text"
              />
            </StyledFilterGroup>
            <StyledSelectGroup>
              <TransactionStatusSelect
                checkedStatus={filterData["status.value"]}
                setCheckedStatus={(data) => setFilterData({ ...filterData, "status.value": data, page: 1 })}
                defaultOption={true}
              />
            </StyledSelectGroup>
          </StyledFilterBlock>
          <StyledFilterBlockTitle>
            {t("filter.amount")}:
          </StyledFilterBlockTitle>
          <StyledFilterBlock col="2">
            <StyledFilterGroup>
              <label htmlFor="amount[gte]">
                {t("filter.amountFrom")}
              </label>
              <DelayInput
                id="amount[gte]"
                delayTimeout={2000}
                onChange={event => setFilterData({
                  ...filterData,
                  "amount[gte]": event.target.value,
                  page: 1
                })}
                name="amount[gte]"
                value={filterData["amount[gte]"]}
                type="number"
                placeholder={t("filter.example", { value: 1000 })}
              />
            </StyledFilterGroup>
            <StyledFilterGroup>
              <label htmlFor="amount[lte]">
                {t("filter.amountTo")}
              </label>
              <DelayInput
                id="amount[lte]"
                delayTimeout={2000}
                onChange={event => setFilterData({
                  ...filterData,
                  "amount[lte]": event.target.value,
                  page: 1
                })}
                name="amount[lte]"
                value={filterData["amount[lte]"]}
                type="number"
                placeholder={t("filter.example", { value: 5000 })}
              />
            </StyledFilterGroup>
          </StyledFilterBlock>
          <StyledFilterBlockTitle>
            {t("filter.processedAmount")}:
          </StyledFilterBlockTitle>
          <StyledFilterBlock col="2">
            <StyledFilterGroup>
              <label htmlFor="processedAmount[gte]">
                {t("filter.processedAmountFrom")}
              </label>
              <DelayInput
                id="processedAmount[gte]"
                delayTimeout={2000}
                onChange={event => setFilterData({
                  ...filterData,
                  "processedAmount[gte]": event.target.value,
                  page: 1
                })}
                name="processedAmount[gte]"
                value={filterData["processedAmount[gte]"]}
                type="number"
                placeholder={t("filter.example", { value: 1000 })}
              />
            </StyledFilterGroup>
            <StyledFilterGroup>
              <label htmlFor="processedAmount[lte]">
                {t("filter.processedAmountTo")}
              </label>
              <DelayInput
                id="processedAmount[lte]"
                delayTimeout={2000}
                onChange={event => setFilterData({
                  ...filterData,
                  "processedAmount[lte]": event.target.value,
                  page: 1
                })}
                name="processedAmount[lte]"
                value={filterData["processedAmount[lte]"]}
                type="number"
                placeholder={t("filter.example", { value: 5000 })}
              />
            </StyledFilterGroup>
          </StyledFilterBlock>
          <StyledFilterBlockTitle>
            {t("filter.createdAt")}:
          </StyledFilterBlockTitle>
          <StyledFilterBlock col="2">
            <StyledDatepicker>
              <label htmlFor="dateFrom">
                {t("filter.createdAtFrom")}
              </label>
              <DatePicker
                format="dd-MM-y"
                id="dateFrom"
                name="dateFrom"
                className="date-input"
                onChange={dateFrom => setFilterData({
                  ...filterData,
                  "createDate[gte]": DateToTimestamp(dateFrom),
                  page: 1
                })}
                value={TimestampToDate(filterData["createDate[gte]"])}
              />
            </StyledDatepicker>
            <StyledDatepicker>
              <label htmlFor="dateTo">
                {t("filter.createdAtTo")}
              </label>
              <DatePicker
                format="dd-MM-y"
                id="dateTo"
                name="dateTo"
                className="date-input"
                onChange={dateTo => setFilterData({
                  ...filterData,
                  "createDate[lte]": DateToTimestamp(dateTo),
                  page: 1
                })}
                value={TimestampToDate(filterData["createDate[lte]"])}
              />
            </StyledDatepicker>
          </StyledFilterBlock>
          <StyledFilterBlockTitle>
            {t("filter.startedAt")}:
          </StyledFilterBlockTitle>
          <StyledFilterBlock col="2">
            <StyledDatepicker>
              <label htmlFor="dateFrom">
                {t("filter.startedAtFrom")}
              </label>
              <DatePicker
                format="dd-MM-y"
                id="dateFrom"
                name="dateFrom"
                className="date-input"
                onChange={dateFrom => setFilterData({
                  ...filterData,
                  "startDate[gte]": DateToTimestamp(dateFrom),
                  page: 1
                })}
                value={TimestampToDate(filterData["startDate[gte]"])}
              />
            </StyledDatepicker>
            <StyledDatepicker>
              <label htmlFor="dateTo">
                {t("filter.startedAtTo")}
              </label>
              <DatePicker
                format="dd-MM-y"
                id="dateTo"
                name="dateTo"
                className="date-input"
                onChange={dateTo => setFilterData({
                  ...filterData,
                  "startDate[lte]": DateToTimestamp(dateTo),
                  page: 1
                })}
                value={TimestampToDate(filterData["startDate[lte]"])}
              />
            </StyledDatepicker>
          </StyledFilterBlock>
        </StyledFilterDropdownWrapper>}
      </>
    );
  };

  return (
    <StyledFilterWrapper id="filter">
      <Dropdown
        getPopupContainer={() => document.getElementById("filter")}
        overlay={FilterList}
        trigger={["click"]}
        placement="bottomLeft"
        align={{ overflow: { adjustX: true, adjustY: false } }}
        onVisibleChange={onVisibleChange}
        visible={visible}
        closeOnSelect={false}
      >
        <StyledShowFilterBtn>
          <DefaultButton
            color="success"
          >
            {t("filter.filterBtn")}
          </DefaultButton>
        </StyledShowFilterBtn>
      </Dropdown>
    </StyledFilterWrapper>
  );
};

export default BatchesFilter;